module.exports = __webpack_public_path__ + "static/media/logo.7cf73e86.png";